export interface StorageInterface {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
  clear: () => void;
  getAllKeys: () => string[];
}

let storageImplementation: StorageInterface;

if (typeof window !== 'undefined' && window.localStorage) {
  storageImplementation = {
    getItem: (key: string) => {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        console.warn('Failed to get localStorage item:', error);
        return null;
      }
    },
    setItem: (key: string, value: string) => {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        console.warn('Failed to set localStorage item:', error);
      }
    },
    removeItem: (key: string) => {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        console.warn('Failed to remove localStorage item:', error);
      }
    },
    clear: () => {
      try {
        window.localStorage.clear();
      } catch (error) {
        console.warn('Failed to clear localStorage:', error);
      }
    },
    getAllKeys: () => {
      try {
        return Object.keys(window.localStorage);
      } catch (error) {
        console.warn('Failed to get localStorage keys:', error);
        return [];
      }
    },
  };
} else {
  storageImplementation = {
    getItem: () => null,
    setItem: () => {
      console.warn('setItem is not supported in SSR');
    },
    removeItem: () => {
      console.warn('removeItem is not supported in SSR');
    },
    clear: () => {
      console.warn('clear is not supported in SSR');
    },
    getAllKeys: () => [],
  };
}

export const storage = storageImplementation;

let sessionStorageImplementation: StorageInterface;

if (typeof window !== 'undefined' && window.sessionStorage) {
  sessionStorageImplementation = {
    getItem: (key: string) => {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        console.warn('Failed to get sessionStorage item:', error);
        return null;
      }
    },
    setItem: (key: string, value: string) => {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        console.warn('Failed to set sessionStorage item:', error);
      }
    },
    removeItem: (key: string) => {
      try {
        window.sessionStorage.removeItem(key);
      } catch (error) {
        console.warn('Failed to remove sessionStorage item:', error);
      }
    },
    clear: () => {
      try {
        window.sessionStorage.clear();
      } catch (error) {
        console.warn('Failed to clear sessionStorage:', error);
      }
    },
    getAllKeys: () => {
      try {
        return Object.keys(window.sessionStorage);
      } catch (error) {
        console.warn('Failed to get sessionStorage keys:', error);
        return [];
      }
    },
  };
} else {
  sessionStorageImplementation = {
    getItem: () => null,
    setItem: () => {
      console.warn('setItem is not supported in SSR');
    },
    removeItem: () => {
      console.warn('removeItem is not supported in SSR');
    },
    clear: () => {
      console.warn('clear is not supported in SSR');
    },
    getAllKeys: () => [],
  };
}

export const sessionStorage = sessionStorageImplementation;
